<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Career - Create Job</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Negara"
                v-model="careerData.country"
                :options="optionCountry"
                vertical
                @input="handleCountry"
              />
            </CCol>
            <CCol :col="6">
              <LocationSearch
                  v-model="careerData.city"
                  :options="optionLocation"
                  :loading="loadingLocation"
                  label="Lokasi"
                  @search="searchDistrict"
                  @selected="handleSelectedLocation"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Divisi"
                v-model="careerData.division_id"
                :options="optionEmploymentDivision"
                vertical
                @input="handleEmploymentDivision"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Posisi"
                class="mb-0"
                v-model="careerData.job_position"
                vertical
                placeholder="Posisi"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Job Level"
                :options="optionJobLevel"
                v-model="careerData.job_level"
                vertical
                @input="handleJobLevel"
                placeholder="Select Job Level"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Employment Type"
                :options="optionEmploymentGroup"
                v-model="careerData.employment_type"
                vertical
                @input="handleEmploymentType"
                placeholder="Employment Group"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Employment Status"
                :options="optionEmploymentStatus"
                v-model="careerData.employment_status"
                vertical
                @input="handleEmploymentStatus"
                placeholder="Employment Status"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6" >
              <CTextarea
                label="Meta Description"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_description"
                placeholder="Meta Description"
              />
            </CCol>
            <CCol :col="6" >
              <CTextarea
                label="Meta Keyword"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_keyword"
                placeholder="Meta Keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  label="Minimum Experience (Years)"
                  type="number"
                  v-model.number="careerData.minimum_experience"
                  min="0"
                  placeholder="Enter Minimum Experience"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                  label="Required Candidate"
                  type="number"
                  v-model.number="careerData.required_candidates"
                  min="0"
                  placeholder="Enter Required Candidate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <label class="mb-2 font-weight-bold">Required Skills</label>
              <BadgeInput
                  v-model="careerData.required_skills"
                  placeholder="Add skill and press Enter"
                  badge-color="light"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in-Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tempat Acara"
                class="mb-0"
                v-model="careerData.place"
                vertical
                placeholder="Tempat Acara"
              ></CInput>
            </CCol>
          </CRow>
          <CRow 
            v-if="careerData.employment_type === 'Walk-in Interview'"
            class="form-group"
          >
            <CCol :col="3">
              <CInput
                label="Quota"
                class="mb-0"
                type="number"
                v-model="careerData.quota"
                vertical
                placeholder="Quota"
              />
            </CCol>
            </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tanggal"
                class="mb-0"
                type="date"
                v-model="date"
                vertical
                placeholder="Tanggal"
              />
            </CCol>
            <CCol
              :col="6"
              v-if="careerData.employment_type === 'Walk-in Interview'"
            >
              <CInput
                label="waktu"
                class="mb-0"
                type="text"
                v-model="time"
                placeholder="00:00"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="12">
              <p>Harus Membawa</p>
              <vue-editor
                class="mt-2"
                v-model="content3"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Job Description</p>
              <vue-editor
                class="mt-2"
                v-model="content"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Minimum Qualifications</p>
              <vue-editor
                class="mt-2"
                v-model="content2"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="3">
              <CSelect
                label="Status"
                :options="optionStatus"
                v-model="careerData.status"
                vertical
                @input="handleStatus"
                placeholder="Pilih"
              />
            </CCol>
            <CCol :col="3">
              <CInput
                  label="Priority"
                  type="number"
                  min="1"
                  v-model="careerData.priority"
                  vertical
                  placeholder="Priority"
              />
            </CCol>

          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="updateCareer"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import DivisionUseCase from '../app/usecase/division';
import BadgeInput from "@/components/BadgeInput.vue";
import { watch } from "vue";
import LocationSearch from "@/components/LocationSearch.vue";

export default {
  components: {LocationSearch, BadgeInput, VueEditor },
  name: "JobCreate",

  data() {
    return {
      careerData: {},
      date: "2020-10-01",
      time: "",
      typeE: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionLocation: [],
      content: "",
      content2: "",
      content3: "",
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        ["clean"],
      ],
      optionEmploymentDivision: [],
      optionJobLevel: ["Director", "Chief", "VP", "AVP", "Head", "Manager", "Assistant Manager", "Supervisor", "Lead", "Staff", "Intern"],
      optionEmploymentGroup: ["Reguler", "Walk-in Interview"],
      optionEmploymentStatus: ["Full Time", "Contract", "Part Time", "Intern"],
      optionStatus: ["ACTIVE", "INACTIVE"],
      optionCountry: [
        {value: "indonesia", label: "Indonesia"}, 
        {value: "malaysia", label: "Malaysia"}
      ],
      loadingLocation: false,
      countryCode: "id",
    };
  },
  computed: {
    eventDateTime() {
      return moment(this.date + " " + this.time).format();
    },
  },
  watch: {
    "careerData.country": {
      handler(country) {
        this.countryCode = country === "malaysia" ? "my" : "id";
      },
      immediate: true
    },
  },
  mounted() {
    this.authentication();
    this.getDataByID();
    this.getDivision();
  },
  methods: {
    async getDivision() {
      try {
        const { data, err } = await DivisionUseCase.getAll("page=1&per_page=100&status=ACTIVE");
        if (err || data.data.length == 0) {
          this.err = err;
        } else {
          if (data) {
            this.optionEmploymentDivision = data.data.map(a => {
              return {
                value: a.division_id,
                label: a.division_name
              }
            }).sort((a, b) => a.label.localeCompare(b.label))
          }
        }
      }
      catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    getDataByID() {
      let careerID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/career/${careerID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.

          this.careerData = response.data;
          var date = new Date(this.careerData.datetime_event);
          var dateMoment = moment(
            date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
          ).format("YYYY-MM-DD");
          this.date = dateMoment;
          this.time = date.getHours() + ":" + date.getMinutes();
          this.content = this.careerData.job_description;
          this.content2 = this.careerData.min_qualification;
          this.content3 = this.careerData.note;
          this.countryCode = this.careerData.country === "malaysia" ? "my" : "id";
          this.setInitialDistrict();

          if (typeof this.careerData.required_skills === "string") {
            this.careerData.required_skills = this.careerData.required_skills
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s);
          } else if (!Array.isArray(this.careerData.required_skills)) {
            this.careerData.required_skills = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/career/job" });
    },

    handleJobLevel(event) {
      this.careerData.job_level = event.target.value;
    },
    handleEmploymentType(event) {
      this.careerData.employment_type = event.target.value;
      this.type = event.target.value;
    },
    handleEmploymentStatus(event) {
      this.careerData.employment_status = event.target.value;
    },
    handleStatus(event) {
      this.careerData.status = event.target.value;
    },
    handleEmploymentDivision(event) {
      this.careerData.division_id = event.target.value;
    },
    handleCountry(event) {
      const country = event.target.value;

      this.careerData.country = country;
      this.countryCode = country === "malaysia" ? "my" : "id";

      this.careerData.city = "";
      this.optionLocation = [];
    },
    updateCareer() {
      let careerID = this.$route.params.id;
      this.careerData.quota = Number(this.careerData.quota);
      if (this.careerData.employment_type === "Walk-in-Interview") {
        this.careerData.datetime_event = dateEvent;
      }


      this.careerData.datetime_event = this.eventDateTime;
      this.careerData.job_description = this.content;
      this.careerData.min_qualification = this.content2;
      this.careerData.note = this.content3;
      delete this.careerData.division_name;
      // HANDLE PRIORITY (clean version)
      if (
          this.careerData.priority === "" ||
          this.careerData.priority === null ||
          this.careerData.priority === undefined
      ) {
        delete this.careerData.priority;
      } else {
        const priority = Number(this.careerData.priority);

        if (priority <= 0) {
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: "Priority must be greater than 0",
          });
          return;
        }

        this.careerData.priority = priority;
      }
      axios
        .put(`${this.domain}/v1/career/${careerID}`, this.careerData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Job Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/career/job` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
        });
    },
    async searchDistrict(keyword) {
      if (!keyword || keyword.length < 3) {
        this.optionLocation = [];
        return;
      }

      this.loadingLocation = true;

      try {
        const res = await axios.get(
            `${this.domain}/v1/location/district/data`,
            {
              params: {
                page: 1,
                per_page: 100,
                search: keyword,
                country_code: this.countryCode
              },
              headers: {
                Authorization: this.token,
              },
            }
        );

        this.optionLocation = res.data.data.map(a => ({
          value: a.district_name,
          label: a.district_name
        }));

      } catch (err) {
        console.log(err);
      } finally {
        this.loadingLocation = false;
      }
    },
    async setInitialDistrict() {
      if (!this.careerData.city) return;

      this.loadingLocation = true;

      try {
        const res = await axios.get(
            `${this.domain}/v1/location/district/data`,
            {
              params: {
                page: 1,
                per_page: 100,
                search: this.careerData.city,
                country_code: this.countryCode
              },
              headers: {
                Authorization: this.token,
              },
            }
        );

        const list = res.data.data;

        // 🔥 EXACT MATCH
        const exact = list.find(
            d => d.district_name.toUpperCase() === this.careerData.city.toUpperCase()
        );

        if (exact) {
          this.optionLocation = [{
            value: exact.district_name,
            label: exact.district_name
          }];

          // penting biar ke-select di component
          this.careerData.city = exact.district_name;
        } else {
          // fallback → tetap tampilkan hasil search
          this.optionLocation = list.map(a => ({
            value: a.district_name,
            label: a.district_name
          }));
        }

      } catch (err) {
        console.log(err);
      } finally {
        this.loadingLocation = false;
      }
    },
    handleSelectedLocation(item) {
      this.careerData.city = item.value;
    }
  },
};
</script>

<style scoped>
@import "./Job.css";
</style>
